import {
  atr,
  bollingerBand,
  ema,
  macd,
  rsi,
  sma,
} from 'react-stockcharts/lib/indicator';

const rsiCalculator7 = rsi()
  .options({ windowSize: 7 })
  .merge((d, c) => {
    d.rsi7 = c;
  })
  .accessor(d => d.rsi7);

const rsiCalculator14 = rsi()
  .options({ windowSize: 14 })
  .merge((d, c) => {
    d.rsi14 = c;
  })
  .accessor(d => d.rsi14);

const rsiCalculator20 = rsi()
  .options({ windowSize: 20 })
  .merge((d, c) => {
    d.rsi20 = c;
  })
  .accessor(d => d.rsi20);

const atrCalculator7 = atr()
  .options({ windowSize: 7 })
  .merge((d, c) => {
    d.atr7 = c;
  })
  .accessor(d => d.atr7);

const atrCalculator14 = atr()
  .options({ windowSize: 14 })
  .merge((d, c) => {
    d.atr14 = c;
  })
  .accessor(d => d.atr14);

const atrCalculator20 = atr()
  .options({ windowSize: 20 })
  .merge((d, c) => {
    d.atr20 = c;
  })
  .accessor(d => d.atr20);

const sma10 = sma()
  .options({ windowSize: 10 })
  .merge((d, c) => {
    d.sma10 = c;
  })
  .accessor(d => d.sma10);

const sma20 = sma()
  .options({ windowSize: 20 })
  .merge((d, c) => {
    d.sma20 = c;
  })
  .accessor(d => d.sma20)
  .stroke('#FC8EAC');

const sma50 = sma()
  .options({ windowSize: 50 })
  .merge((d, c) => {
    d.sma50 = c;
  })
  .accessor(d => d.sma50)
  .stroke('#F6BE00');

const sma250 = sma()
  .options({ windowSize: 250 })
  .merge((d, c) => {
    d.sma250 = c;
  })
  .accessor(d => d.sma250)
  .stroke('#B94700');

const ema10 = ema()
  .options({ windowSize: 10 })
  .merge((d, c) => {
    d.ema10 = c;
  })
  .accessor(d => d.ema10);

const ema20 = ema()
  .options({ windowSize: 20 })
  .merge((d, c) => {
    d.ema20 = c;
  })
  .accessor(d => d.ema20);

const ema50 = ema()
  .options({ windowSize: 50 })
  .merge((d, c) => {
    d.ema50 = c;
  })
  .accessor(d => d.ema50);

const ema250 = ema()
  .options({ windowSize: 250 })
  .merge((d, c) => {
    d.ema250 = c;
  })
  .accessor(d => d.ema250);

const bb = bollingerBand()
  .merge((d, c) => {
    d.bb = c;
  })
  .accessor(d => d.bb);

const macdCalculator = macd()
  .options({
    fast: 12,
    slow: 26,
    signal: 9,
  })
  .merge((d, c) => {
    d.macd = c;
  })
  .accessor(d => d.macd);

export const calculateMacd = initialData =>
  macdCalculator(
    bb(
      ema10(
        ema20(
          ema50(
            ema250(
              sma10(
                sma20(
                  sma50(
                    sma250(
                      rsiCalculator7(
                        rsiCalculator14(
                          rsiCalculator20(
                            atrCalculator7(
                              atrCalculator14(atrCalculator20(initialData))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
